"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasStageActionWorkflow = void 0;
const azavista_types_1 = require("@azavista/azavista-types");
const Types_1 = require("./Types");
const CanvasWorkflow_1 = require("./CanvasWorkflow");
const validation_1 = require("./validation/validation");
class CanvasStageActionWorkflow extends CanvasWorkflow_1.CanvasWorkflow {
    constructor() {
        super();
        this.inputPin = [Types_1.InputPin.INPUT];
        this.outputPin = [Types_1.OutputPin.OUTPUT];
        this.type = Types_1.WorkflowType.STAGE_ACTION;
        this.settings = this.getDefaultSettings();
        this.customProcess = {
            stage_action_engagement_sequence: null,
        };
        this.schema = validation_1.StageActionSchema;
    }
    getDefaultSettings() {
        return {
            email_campaign_id: null,
            stage_name: '',
            count_as: azavista_types_1.CrmStatus.NEW,
            disable_manual_stage_change: false,
            next_workflow_ids: {
                next_workflow: null,
            },
        };
    }
    setNextWorkflow(pin, next_workflow_id) {
        this.setDefaultNextWorkflow(pin, next_workflow_id);
    }
    getNextWorkflows() {
        const o = {};
        o[Types_1.OutputPin.OUTPUT] = this.getDefaultNextWorkflow();
        return o;
    }
    setCustomProcess(s, p) {
        if (s === 'stage_action_engagement_sequence') {
            this.customProcess.stage_action_engagement_sequence = p;
        }
    }
    getProperties() {
        return [
            {
                attribute: 'stage_action_engagement_sequence',
                datasource: null,
                label: 'ENGAGEMENT_SEQUENCE',
                type: 'process',
                mandatory: false,
                value: null,
            },
            {
                attribute: 'stage_name',
                datasource: null,
                label: 'STAGE_NAME',
                type: 'text',
                mandatory: true,
                value: this.settings.stage_name,
            },
            {
                attribute: 'email_campaign_id',
                datasource: 'Email',
                label: 'THANK_YOU_EMAIL',
                type: 'select',
                mandatory: false,
                value: this.settings.email_campaign_id,
            },
            {
                attribute: 'count_as',
                datasource: 'CrmStatus',
                label: 'COUNT_AS',
                type: 'select',
                mandatory: true,
                value: this.settings.count_as,
            },
            {
                attribute: 'disable_manual_stage_change',
                datasource: null,
                label: 'DISABLE_MANUAL_STAGE_CHANGE',
                type: 'boolean',
                mandatory: false,
                value: this.settings.disable_manual_stage_change,
            },
        ];
    }
}
exports.CanvasStageActionWorkflow = CanvasStageActionWorkflow;
